/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Grid } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'redux/store'
import StudentCard from './studentCard'
import KpiPerformanceChart from '../kpi/KpiPerformanceChart'
import MainTable from 'components/organisms/tables/MainTable'
import MainTableFiltersForm from 'components/organisms/forms/tableFilters/MainTableFiltersForm'
import { useTableModel } from 'utils/tableModels/useKpiEvaluationsTableModel'
import { kpiEvaluationsAPI, useGET_kpiEvaluationsQuery } from 'redux/api/kpiEvaluationsApi'
import { clearAllFilters, setSearch } from 'redux/ui/kpiEvaluationsUI'
import formModel, { initialValues } from 'utils/tableFilterModels/kpiTableFilterModel'
import ExtraFilters from 'components/organisms/forms/tableFilters/kpiEvaluations/ExtraFilters'
import { useGET_learningStyleQuestionsQuery } from 'redux/api/studentsApi'
import DialogPopup from 'components/molecules/DialogPopup'
import { setKpiSubject } from 'redux/ui/kpiEvaluationsUI'
import KpiStudent from '../kpi/KpiStudent'


interface IProps {
  student: any
  tabText?: string
  tabKey?: string
}

const StudentKpiTracker: FC<IProps> = ({student}) => {

  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const reduxKey = 'kpiEvaluations'

  const activeFilters = useSelector((state: RootState) => state[reduxKey].activeFilters)

  const filters = {
    search: useSelector((state: RootState) => state[reduxKey].tableFilters.search),
    grade_level: useSelector((state: RootState) => state[reduxKey].tableFilters.grade_level),
    subject: useSelector((state: RootState) => state[reduxKey].tableFilters.subject),
    category: useSelector((state: RootState) => state[reduxKey].tableFilters.category),
    group: useSelector((state: RootState) => state[reduxKey].tableFilters.group),
    student: student.student_profile_id,
    created_at_after: useSelector((state: RootState) => state[reduxKey].tableFilters.created_after),
    created_at_before: useSelector((state: RootState) => state[reduxKey].tableFilters.created_before),
  }

  const {
    data: learningStyle,
  } = useGET_learningStyleQuestionsQuery(student.student_profile_id, {skip: !student})
      
  const kpiSubject = useSelector((state: RootState) => state['kpiEvaluations'].kpiSubject)
  const kpiStudent = student.student_profile_id

  return (
    <>
  
      <MainTable
        useTableModel={useTableModel}
        getTableData={useGET_kpiEvaluationsQuery}
        filters={filters}
        header={
          <>
            <MainTableFiltersForm
              reduxKey={reduxKey}
              tag="kpi-evaluations"
              entityName={t('common.kpi-tracker')}
              api={kpiEvaluationsAPI}
              setSearch={setSearch}
              clearAllFilters={clearAllFilters}
              formModel={formModel}
              initialValues={initialValues}
              activeFilters={activeFilters}
              openFilters
              hideDefaultActions
              >
              <ExtraFilters hideStudentFields />
            </MainTableFiltersForm>

            <Box mt={1} mb={3}>
              <Grid container rowSpacing={3} columnSpacing={3}>
                <Grid item xs={12} md={4}>
                  <StudentCard student={student} learningStyle={learningStyle} step={1}/>
                </Grid>
                <Grid item xs={12} md={8}>
                  <KpiPerformanceChart filters={filters}/>
                </Grid>
              </Grid>
            </Box>  
          </>
        }
        />


       {kpiStudent && kpiSubject && <DialogPopup
            title={t('common.kpi-tracker')}
            onClose={() => {
              dispatch(setKpiSubject(null))
            }}
            open
            popupWidth={'1400px'}
            popupPadding={0}
          >
            <KpiStudent student={kpiStudent} subject={kpiSubject} />
        </DialogPopup>}
    </>
  )
}

export default StudentKpiTracker
